import React from "react";

export const exportPlayerCareerStatsDetails = (playerCareerStatsData) => {
  const { playerReadonlyData, playerBasicStats, playerAdvStats } =
    playerCareerStatsData;

  const styleHeaderCss = {
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "e6eefb" },
    },
    font: { sz: "11", bold: true, color: { argb: "1d428a" } },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
    alignment: {
      wrapText: true,
      horizontal: "center",
      vertical: "top",
    },
  };

  const PlayersData = {
    title: "",
    headerNames: [
      {
        title: "Name",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "College or Club",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Team",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Birth Place",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      Object.keys(playerReadonlyData).length === 0
        ? []
        : [
            {
              playerName: playerReadonlyData.playerName
                ? playerReadonlyData.playerName
                : "--",
              collegeOrClub: playerReadonlyData.collegeOrClub
                ? playerReadonlyData.collegeOrClub
                : "--",
              teamName: playerReadonlyData.teamName
                ? playerReadonlyData.teamName
                : "--",
              birthPlace: playerReadonlyData.birthPlace
                ? playerReadonlyData.birthPlace
                : "--",
            },
          ],
    columnStyles: Array(4).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const careerBasicStats = {
    title: "Career Basic Stats",
    headerNames: [
      {
        title: "Season Year",
        field: "seasonYear",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: "Height",
        field: "height",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Weight`,
        field: "weight",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Position`,
        field: "position",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Jersey#`,
        field: "jerseyNumber",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Experience`,
        field: "experience",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `GP`,
        field: "gamesPlayed",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `GS`,
        field: "gamesStarted",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `Min`,
        field: "minutes",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `FGM`,
        field: "fieldGoalsMade",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `FGA`,
        field: "fieldGoalsAtt",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `FG%`,
        field: "fieldGoalsPct",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `2PM`,
        field: "twoPointsMade",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `2PA`,
        field: "twoPointsAtt",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `2P%`,
        field: "twoPointsPct",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `3PM`,
        field: "threePointsMade",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `3PA`,
        field: "threePointsAtt",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `3P%`,
        field: "threePointsPct",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `FTM`,
        field: "freeThrowsMade",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `FTA`,
        field: "freeThrowsAtt",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `FT%`,
        field: "freeThrowsPct",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `ORB`,
        field: "offensiveRebounds",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `DRB`,
        field: "defensiveRebounds",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `REB`,
        field: "rebounds",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `AST`,
        field: "assists",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `TO`,
        field: "turnovers",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `STL`,
        field: "steals",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `BLK`,
        field: "blocks",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `PF`,
        field: "personalFouls",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `TF`,
        field: "techFouls",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `PTS`,
        field: "points",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `FF`,
        field: "flagrantFouls",
        width: 30,
        style: styleHeaderCss,
      },
      {
        title: `TS%`,
        field: "trueShootingPct",
        width: 30,
        style: styleHeaderCss,
      },
    ],
    data:
      playerBasicStats && playerBasicStats.length > 0
        ? playerBasicStats.map((record) => ({
            seasonYear: record.seasonYear ? record.seasonYear.toString() : "--",
            height: record.height ? record.height.toString() : "--",
            weight: record.weight ? record.weight.toString() : "--",
            position: record.position ? record.position.toString() : "--",
            jerseyNumber: record.jerseyNumber
              ? record.jerseyNumber.toString()
              : "--",
            experience: record.experience ? record.experience.toString() : "--",
            gamesPlayed: record.gamesPlayed
              ? record.gamesPlayed.toString()
              : "--",
            gamesStarted: record.gamesStarted
              ? record.gamesStarted.toString()
              : "--",
            minutes: record.minutes ? record.minutes.toString() : "--",
            fieldGoalsMade: record.fieldGoalsMade
              ? record.fieldGoalsMade.toString()
              : "--",
            fieldGoalsAtt: record.fieldGoalsAtt
              ? record.fieldGoalsAtt.toString()
              : "--",
            fieldGoalsPct: record.fieldGoalsPct
              ? record.fieldGoalsPct.toString()
              : "--",
            twoPointsMade: record.twoPointsMade
              ? record.twoPointsMade.toString()
              : "--",
            twoPointsAtt: record.twoPointsAtt
              ? record.twoPointsAtt.toString()
              : "--",
            twoPointsPct: record.twoPointsPct
              ? record.twoPointsPct.toString()
              : "--",
            threePointsMade: record.threePointsMade
              ? record.threePointsMade.toString()
              : "--",
            threePointsAtt: record.threePointsAtt
              ? record.threePointsAtt.toString()
              : "--",
            threePointsPct: record.threePointsPct
              ? record.threePointsPct.toString()
              : "--",
            freeThrowsMade: record.freeThrowsMade
              ? record.freeThrowsMade.toString()
              : "--",
            freeThrowsAtt: record.freeThrowsAtt
              ? record.freeThrowsAtt.toString()
              : "--",
            freeThrowsPct: record.freeThrowsPct
              ? record.freeThrowsPct.toString()
              : "--",
            offensiveRebounds: record.offensiveRebounds
              ? record.offensiveRebounds.toString()
              : "--",
            defensiveRebounds: record.defensiveRebounds
              ? record.defensiveRebounds.toString()
              : "--",
            rebounds: record.rebounds ? record.rebounds.toString() : "--",
            assists: record.assists ? record.assists.toString() : "--",
            turnovers: record.turnovers ? record.turnovers.toString() : "--",
            steals: record.steals ? record.steals.toString() : "--",
            blocks: record.blocks ? record.blocks.toString() : "--",
            personalFouls: record.personalFouls
              ? record.personalFouls.toString()
              : "--",
            techFouls: record.techFouls ? record.techFouls.toString() : "--",
            points: record.points ? record.points.toString() : "--",
            flagrantFouls: record.flagrantFouls
              ? record.flagrantFouls.toString()
              : "--",
            trueShootingPct: record.trueShootingPct
              ? record.trueShootingPct.toString()
              : "--",
          }))
        : [],
    columnStyles: Array(33).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };

  const careerAdvanceStats = {
    title: "Career Advanced Stats",
    headerNames: [
      {
        title: "Season Year",
        field: "seasonYear",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: "TS%",
        field: "tS_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `eFG%`,
        field: "eFG_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `3PA`,
        field: "threePAr",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `FTr`,
        field: "fTr",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `ORB%`,
        field: "orB_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `DRB%`,
        field: "drB_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `TRB%`,
        field: "trB_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `AST%`,
        field: "asT_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `STL%`,
        field: "stL_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `BLK%`,
        field: "blK_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `TOV%`,
        field: "toV_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `USG%`,
        field: "usG_Pct",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `ORtg`,
        field: "oRtg",
        width: 20,
        style: styleHeaderCss,
      },
      {
        title: `DRtg`,
        field: "dRtg",
        width: 20,
        style: styleHeaderCss,
      },
    ],
    data:
      playerAdvStats && playerAdvStats.length > 0
        ? playerAdvStats.map((record) => ({
            seasonYear: record.seasonYear ? record.seasonYear.toString() : "--",
            tS_Pct: record.tS_Pct ? record.tS_Pct.toString() : "--",
            eFG_Pct: record.eFG_Pct ? record.eFG_Pct.toString() : "--",
            threePAr: record.threePAr ? record.threePAr.toString() : "--",
            fTr: record.fTr ? record.fTr.toString() : "--",
            orB_Pct: record.orB_Pct ? record.orB_Pct.toString() : "--",
            drB_Pct: record.drB_Pct ? record.drB_Pct.toString() : "--",
            trB_Pct: record.trB_Pct ? record.trB_Pct.toString() : "--",
            asT_Pct: record.asT_Pct ? record.asT_Pct.toString() : "--",
            stL_Pct: record.stL_Pct ? record.stL_Pct.toString() : "--",
            blK_Pct: record.blK_Pct ? record.blK_Pct.toString() : "--",
            toV_Pct: record.toV_Pct ? record.toV_Pct.toString() : "--",
            usG_Pct: record.usG_Pct ? record.usG_Pct.toString() : "--",
            oRtg: record.oRtg ? record.oRtg.toString() : "--",
            dRtg: record.dRtg ? record.dRtg.toString() : "--",
          }))
        : [],
    columnStyles: Array(15).fill({
      font: { size: 11 },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
    }),
  };
  return [PlayersData, careerBasicStats, careerAdvanceStats];
};
